const baseStyle = {
  flexDirection: 'row',
  space: 1,
  px: '2',
  py: '0.5',
  alignItems: 'center',
  _text: { fontSize: 'sm', fontWeight: 'medium' },
};

const solidColorScheme: { [key: string]: string } = {
  error: 'lightText',
  warning: 'darkText',
  success: 'lightText',
  secondary: 'lightText',
  gray: 'lightText',
};

function variantSolid({ colorScheme }: Record<string, any>) {
  return {
    _text: {
      color: `${solidColorScheme[colorScheme]}`,
    },
    _icon: {
      color: `${solidColorScheme[colorScheme]}`,
    },
    bgColor: `${colorScheme}.500`,
    borderWidth: '1',
    borderColor: 'transparent',
    borderRadius: '3xl',
  };
}

const subtleColorSchemeLevel: { [key: string]: string } = {
  error: '500',
  warning: '800',
  success: '500',
  secondary: '500',
  gray: '500',
};

function variantSubtle({ colorScheme }: Record<string, any>) {
  return {
    _text: {
      color: `${colorScheme}.${subtleColorSchemeLevel[colorScheme]}`,
    },
    _icon: { color: `${colorScheme}.${subtleColorSchemeLevel[colorScheme]}` },
    _light: { bgColor: `${colorScheme}.50` },
    _dark: { bgColor: `${colorScheme}.50` },
    borderWidth: '1',
    borderRadius: '3xl',
    borderColor: 'transparent',
  };
}

const variants = {
  solid: variantSolid,
  subtle: variantSubtle,
  outline: variantSolid,
};

const sizes = {
  sm: {
    px: '2',
    py: '0',
    _icon: {
      size: '3',
    },
    _text: {
      fontSize: 'sm',
      lineHeight: 'sm',
    },
  },
  lg: {
    px: '3',
    py: '2',
    _icon: {
      size: '4',
    },
    _text: {
      fontSize: 'md',
      lineHeight: 'md',
    },
  },
};

const defaultProps = {
  variant: 'subtle',
  colorScheme: 'gray',
  size: 'sm',
};

export default {
  baseStyle,
  sizes,
  variants,
  defaultProps,
};
